/* eslint-disable class-methods-use-this */
// Disabled camelcase rule because we can't control the names of variables like phone_number
/* eslint-disable camelcase */
const axios = require('axios')

const mergePhoneNumbers = (phone = [], phone_number = []) => {
  const phoneArray = Array.isArray(phone) ? phone : [phone]
  const phoneNumberArray = Array.isArray(phone_number)
    ? phone_number
    : [phone_number]
  return [...phoneArray, ...phoneNumberArray]
}

class TCPAClient {
  /**
   * Create a TCPAClient
   * @param {string} baseURL - baseURL is prepended to the url and is based on environment
   */
  constructor(baseURL) {
    if (!baseURL) {
      throw Error('failed to initialize TCPAClient: missing baseURL')
    }
    this.client = axios.create({ baseURL })
  }

  static formatPhoneNumber(input) {
    // Strip any non-digit characters.
    let result = input.replace(/[^0-9]/g, '')

    // Trim down to 10 characters, from the end, to remove a country code, if it's present.
    result = result.substring(result.length - 10)

    // Return as an integer.
    return parseInt(result, 10)
  }

  submit(data, consent_given = true) {
    return new Promise((resolve, reject) => {
      const {
        phone_number,
        phone,
        brand,
        request_id,
        xxTrustedFormToken,
        xxTrustedFormCertUrl,
      } = data

      // Some forms use phone, others use phone_number so we need to support both.
      const tcpaPhone = mergePhoneNumbers(phone, phone_number)

      // If there was no phone number in the provided form data then we don't need to do anything.
      if (!tcpaPhone.length) {
        return resolve()
      }

      const tcpaData = {
        brand,
        request_id,
        xxTrustedFormToken,
        xxTrustedFormCertUrl,
        phone: tcpaPhone.map(TCPAClient.formatPhoneNumber),
        consent_given
      }

      return this.client
        .post('/v1/create', tcpaData)
        .then(resolve)
        .catch(reject)
    })
  }

  verifyByPhone(phoneNumber) {
    return this.client.get(`/v1/verify/phone/${phoneNumber}`)
  }

  verifyByPhoneAndBrand(phoneNumber, brandCode) {
    return this.client.get(`/v2/verify/phone/${phoneNumber}/${brandCode}`)
  }

  verifyByRequestID(requestID) {
    return this.client.get(`/v1/verify/request/${requestID}`)
  }

  verifyByConsent(consent) {
    return this.client.get(`/v1/verify/consent/${consent}`)
  }
}

module.exports = TCPAClient
